export enum LivenessClassNames {
  CameraModule = 'amplify-liveness-camera-module',
  CancelContainer = 'amplify-liveness-cancel-container',
  CancelButton = 'amplify-liveness-cancel-button',
  CountdownContainer = 'amplify-liveness-countdown-container',
  DescriptionBullet = 'amplify-liveness-description-bullet',
  DescriptionBulletIndex = 'amplify-liveness-description-bullet__index',
  DescriptionBulletIndexText = 'amplify-liveness-description-bullet__index__text',
  DescriptionBulletMessage = 'amplify-liveness-description-bullet__message',
  ErrorModal = 'amplify-liveness-error-modal',
  ErrorModalHeading = 'amplify-liveness-error-modal__heading',
  FadeOut = 'amplify-liveness-fade-out',
  FreshnessCanvas = 'amplify-liveness-freshness-canvas',
  InstructionList = 'amplify-liveness-instruction-list',
  InstructionOverlay = 'amplify-liveness-instruction-overlay',
  Hint = 'amplify-liveness-hint',
  HintText = 'amplify-liveness-hint__text',
  LandscapeErrorModal = 'amplify-liveness-landscape-error-modal',
  LandscapeErrorModalButton = 'amplify-liveness-landscape-error-modal__button',
  LandscapeErrorModalHeader = 'amplify-liveness-landscape-error-modal__header',
  Loader = 'amplify-liveness-loader',
  MatchIndicator = 'amplify-liveness-match-indicator',
  OvalCanvas = 'amplify-liveness-oval-canvas',
  OpaqueOverlay = 'amplify-liveness-overlay-opaque',
  Overlay = 'amplify-liveness-overlay',
  Popover = 'amplify-liveness-popover',
  PopoverContainer = 'amplify-liveness-popover__container',
  PopoverAnchor = 'amplify-liveness-popover__anchor',
  PopoverAnchorSecondary = 'amplify-liveness-popover__anchor-secondary',
  RecordingIconContainer = 'amplify-liveness-recording-icon-container',
  RecordingIcon = 'amplify-liveness-recording-icon',
  StartScreenCameraSelect = 'amplify-liveness-start-screen-camera-select',
  StartScreenCameraSelectContainer = 'amplify-liveness-start-screen-camera-select__container',
  StartScreenCameraWaiting = 'amplify-liveness-start-screen-camera-waiting',
  StartScreenHeader = 'amplify-liveness-start-screen-header',
  StartScreenHeaderBody = 'amplify-liveness-start-screen-header__body',
  StartScreenHeaderHeading = 'amplify-liveness-start-screen-header__heading',
  StartScreenWarning = 'amplify-liveness-start-screen-warning',
  StartScreenInstructions = 'amplify-liveness-start-screen-instructions',
  StartScreenInstructionsHeading = 'amplify-liveness-start-screen-instructions__heading',
  Toast = 'amplify-liveness-toast',
  ToastContainer = 'amplify-liveness-toast__container',
  ToastMessage = 'amplify-liveness-toast__message',
  Video = 'amplify-liveness-video',
  VideoAnchor = 'amplify-liveness-video-anchor',
}
